import { Pipe, PipeTransform } from '@angular/core';
import { ProjectTeamMember } from '~ci-portal/domains/ci-project';

@Pipe({ name: 'memberName' })
export class MemberNamePipe implements PipeTransform {
  transform(member?: ProjectTeamMember): string {
    return member?.name ?? '';
  }
}
